import { BaseNode } from "./BaseNode";

export class DummyNode extends BaseNode {

    constructor(label: string = 'Loading...'){
        super(undefined,[],label);
    }
}